import script from "./AuditoriaView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuditoriaView.vue?vue&type=script&setup=true&lang=ts"

import "./AuditoriaView.vue?vue&type=style&index=0&id=bbf4d3b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbf4d3b0"]])

export default __exports__